var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid grid--full-height", attrs: { id: "login-layout" } },
    [
      _c(
        "div",
        {
          staticClass:
            "grid__cell grid grid--column grid--jc-middle grid--ai-middle"
        },
        [
          _c("div", { staticClass: "login__wrapper" }, [
            _vm.$maDomain
              ? _c("img", {
                  staticClass: "mg mg--b-2",
                  attrs: { src: require("@/assets/logo_ma_orange.svg") }
                })
              : _c("img", {
                  staticClass: "mg mg--b-2",
                  staticStyle: { width: "160px" },
                  attrs: { src: require("@/assets/allianz_blue.png") }
                }),
            _c(
              "div",
              { staticClass: "sso-status-message mg mg--t-4" },
              [
                _c("p", { staticClass: "headline-small gray mg mg--b-2" }, [
                  _vm._v(_vm._s(_vm.$t("login.sso_processing")))
                ]),
                _c("p", { staticClass: "text-medium gray mg mg--b-2" }, [
                  _vm._v(_vm._s(_vm.$t("login.sso_wait")))
                ]),
                _vm.loadingSSO
                  ? [_c("ma-loader", { class: { active: _vm.loadingSSO } })]
                  : _vm._e(),
                _vm.errorSSO
                  ? [
                      _c(
                        "p",
                        { staticClass: "headline-small red mg mg--b-2" },
                        [_vm._v(_vm._s(_vm.$t("login.sso_error_title")))]
                      ),
                      _c("p", { staticClass: "text-medium gray mg mg--b-2" }, [
                        _vm._v(_vm._s(_vm.$t("login.sso_error_msg")))
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "mainBlue mg mg--t-4",
                          on: {
                            click: function($event) {
                              return _vm.$router.push({ name: "login" })
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("login.back_to_login")))]
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ])
        ]
      ),
      _c("div", { staticClass: "grid__cell" }, [
        _c("div", {
          staticClass: "login__bg",
          style: {
            backgroundImage:
              "url(" +
              require("@/assets/images/views/login/login_bg_1x.png") +
              ")"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }